/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { Link } from 'react-router-dom';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';

import backArrowIconSrc from './back.svg';
import styles from './Breadcrumbs.module.scss';

export type BreadcrumbsProps = {
  children: (JSX.Element | null)[] | JSX.Element;
  className?: string;
  style?: React.CSSProperties;
  goBackLink: string;
};

export function Breadcrumbs({ children, className, style, goBackLink }: BreadcrumbsProps) {
  return (
    <div className={`${styles.container} ${className}`} style={style}>
      <Link to={goBackLink}>
        <img src={backArrowIconSrc} alt="Go Back" className={styles.backIcon} width="20" height="26" />
      </Link>
      <MuiBreadcrumbs aria-label="breadcrumb" className={styles.breadcrumbs}>
        {children}
      </MuiBreadcrumbs>
    </div>
  );
}
